// extracted by mini-css-extract-plugin
export var icon = "_a9-3";
export var subtitle = "_a9-2";
export var title = "_a9-1";
export var value = "_a9-0";